/* eslint-disable */

import React from 'react'

const GridDataNotFound = () => {
    return (
        <div style={{ fontSize: '25px', fontWeight: '500', color: "#626262" }}>No Rows To Show</div>
    )
}

export default GridDataNotFound